import { Resource as e } from "@coveo/platform-client";
//#region src/resources/NotificationEventResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/notifications/events/send";
	}
	send(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/${e}`, {}), n);
	}
	sendMultiple(e, n) {
		return this.api.post(this.buildPath(t.baseUrl, n), e);
	}
};
//#endregion
export { t as NotificationEventResource };

//# sourceMappingURL=NotificationEventResource.js.map